import * as React from "react";
import { IconProps } from "../types";

const ArrowRotateCounterclockwiseIcon = React.forwardRef<
  SVGSVGElement,
  IconProps
>(({ color = "currentColor", ...props }, forwardedRef) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
      {...props}
    >
      <path
        d="M9 17C6.347 17 3.873 15.689 2.38 13.492C2.147 13.15 2.236 12.683 2.579 12.45C2.921 12.218 3.388 12.305 3.621 12.649C4.834 14.434 6.846 15.5 9.001 15.5C12.585 15.5 15.501 12.584 15.501 9C15.501 5.416 12.585 2.5 9.001 2.5C6.416 2.5 4.077 4.031 3.042 6.4C2.875 6.779 2.434 6.953 2.054 6.787C1.674 6.621 1.501 6.179 1.667 5.799C2.94 2.884 5.819 1 9 1C13.411 1 17 4.589 17 9C17 13.411 13.411 17 9 17Z"
        fill={color}
      />
      <path
        d="M2.287 7C1.918 7 1.597 6.728 1.545 6.353L1.137 3.408C1.08 2.997 1.366 2.619 1.777 2.562C2.187 2.502 2.566 2.791 2.623 3.202L2.928 5.404L5.129 5.099C5.536 5.045 5.918 5.329 5.975 5.74C6.032 6.15 5.745 6.529 5.334 6.586L2.39 6.993C2.355 6.997 2.322 7 2.287 7Z"
        fill={color}
      />
    </svg>
  );
});

export default ArrowRotateCounterclockwiseIcon;
